import * as Sentry from '@sentry/core';
import { useMutation } from 'react-query';
import { ws_connection_api } from '@axo/shared/data-access/api';
import { useAPI } from '@axo/shared/data-access/provider';

export const useCreateTicket = () => {
  const api = useAPI();

  const mutation = useMutation(
    (variables: { tokenOverride?: string } | void) =>
      ws_connection_api.createTicket(
        variables?.tokenOverride ? { ...api, token: variables.tokenOverride } : api
      )(),
    {
      onError: (error) => {
        Sentry.captureException(
          new Error('WebSocket ticket creation failed'),
          { extra: { error } }
        );
      },
      retry: 5,
      retryDelay: (attempt) => Math.min(1000 * 2 ** attempt, 30000), // Exponential backoff: 1s, 2s, 4s, 8s, 16s, ... up to 30s
    }
  );

  return mutation;
};
